import { tallyTokens } from "../../theme.tsx";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Box } from "@mui/material";
import { LogoutIcon } from "../icons/DrawerNavIcons.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import { logout } from "../../store/auth.tsx";
import { fetchExamples } from "../../store/example.tsx";
import type { RootState } from "../../store/types.tsx";

interface LogoutDrawerActionProps {
  closeDrawer: () => void;
}

const LogoutDrawerAction: React.FC<LogoutDrawerActionProps> = ({
  closeDrawer,
}) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(
    (state: RootState) => state.authState.isLoggedIn,
  );

  const handleLogout = () => {
    closeDrawer();
    dispatch(logout());
    dispatch({ type: "RESET_STATE" });
    dispatch(fetchExamples({ isLoggedIn: false }) as any);
  };

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Typography
      variant="h4"
      onClick={handleLogout}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        // The draft sets the footer's log out row a touch smaller than the
        // nav rows above it, on the same 10px inset.
        fontSize: "13.5px !important",
        width: "100%",
        boxSizing: "border-box",
        lineHeight: 1.3,
        margin: "0",
        px: "10px",
        py: "8px",
        color: tallyTokens.ink2,
        fontWeight: 500,
        borderRadius: `${tallyTokens.radius.md}px`,
        transition: "background-color 0.15s ease, color 0.15s ease",
        "&:hover": {
          backgroundColor: tallyTokens.surface3,
          color: tallyTokens.ink,
        },
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "18px",
          height: "18px",
        }}
      >
        <LogoutIcon />
      </Box>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "left",
        }}
      >
        {i18n._(
          msg({ message: "Logout", context: "Action to logout the user" }),
        )}
      </Box>
    </Typography>
  );
};

export default LogoutDrawerAction;
